// eslint-disable-next-line import/prefer-default-export
export const menuList = (data) =>
  data.map((item) => ({
    name: item?.name,
    sequencialId: item?.sequencialId,
    optionId: item?.optionId,
    url: item?.url,
    children: item?.children
  }))
